import { SxProps, Theme } from '@mui/material';

export const tableContainer: SxProps<Theme> = { overflowX: 'auto' };

export const fixedCell: SxProps<Theme> = { whiteSpace: 'nowrap' };

export const descriptionCell: SxProps<Theme> = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  width: '100%',
};
